module.exports = __webpack_public_path__ + "img/interligacao.7c6cf55a.svg";